import * as React from 'react';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { IMediaQueryProps, WithMediaQuery } from '../../../layout/withMediaQuery';
import ConfirmButton from '../../../ui-components/Button/ConfirmButton';
import CancelButton from '../../../ui-components/Button/CancelButton';
import { styles } from "../styles"
import TextField from '../../../ui-components/TextField/TextField';
import { tag, emptyTag } from '../../../model/tag';

interface IProps extends IMediaQueryProps, IInnerProps {

}

interface IInnerProps extends StyledComponentProps {
    onConfirm: (tag: tag) => any;
    onCancel: () => any;
    open: boolean;
}
interface IState {
    newTag: tag;
}


class AddTagDialog extends React.Component<IProps, IState> {

    /**
     *
     */
    constructor(p, c) {
        super(p, c);
        this.state = {
            newTag: emptyTag(),
        }
    }

    componentDidUpdate(prevProps: IProps) {
        if (!prevProps.open && this.props.open) {
            this.setState({
                newTag: emptyTag(),
            })
        }
    }

    checkTagInvalid = () => {
        var res = (this.state.newTag.code !== undefined && this.state.newTag.code !== null && this.state.newTag.code.trim() !== "")
            && (this.state.newTag.description !== undefined && this.state.newTag.description !== null && this.state.newTag.description.trim() !== "")
        return res;
    }


    updateTag = (tag: tag) => {
        this.setState({
            newTag: tag,
        });
    }



    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={(e) => this.props.onCancel()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {<DialogTitle id="alert-dialog-title">Aggiungi Tag</DialogTitle>}
                < DialogContent className={this.props.classes.reservationSlotDetailDialogContent} >
                    <Grid container>
                        <Grid item xs={12}>
                            <TextField
                                label={"Codice"}
                                value={this.state.newTag.code}
                                onChange={(value) => this.updateTag({ ...this.state.newTag, code: value })}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={"Descrizione"}
                                value={this.state.newTag.description}
                                onChange={(value) => this.updateTag({ ...this.state.newTag, description: value })}
                            />

                        </Grid>
                    </Grid>
                </DialogContent >
                <DialogActions className={this.props.classes.reservationSlotDetailDialogActions}>
                    <ConfirmButton disabled={!this.checkTagInvalid()} onClick={() => this.props.onConfirm(this.state.newTag)} text={"Aggiungi"} />
                    <CancelButton onClick={this.props.onCancel} />
                </DialogActions>
            </Dialog >
        );
    }
}

export default withStyles(styles as any)(WithMediaQuery(AddTagDialog)) as React.ComponentType<IInnerProps>;